import { TimeInput } from "@msuite/ui/date-input";
import { Divider } from "@msuite/ui/divider";
import { Select } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import { getAttendanceWorksiteTranslationKey, worksites } from "@msuite/utils/attendances";
import type { EditAttendanceFormSchema } from "@msuite/utils/schemas";
import { useFormContext, useWatch } from "react-hook-form";
import { ProjectSearch } from "@/components/projects";

export function AttendanceForm() {
	/** Hooks */
	const methods = useFormContext<EditAttendanceFormSchema>();
	const { t } = useTranslation();
	const [worksite] = useWatch({ control: methods.control, name: ["worksite"] });

	/** Render */
	return (
		<div className="v-stack gap-4">
			<div className="grid grid-cols-2 gap-6">
				<TimeInput
					label={t("dates.start_time")}
					control={methods.control}
					name="startTime"
					granularity="second"
				/>
				<TimeInput
					label={t("dates.end_time")}
					control={methods.control}
					name="endTime"
					granularity="second"
				/>
			</div>
			<Divider variant="modal" />
			<Select
				isRequired
				label={t("users.worksite")}
				control={methods.control}
				name="worksite"
				isNullable={false}
				options={worksites.map((worksite) => ({
					label: t(getAttendanceWorksiteTranslationKey(worksite)),
					value: worksite,
					item: { worksite },
				}))}
			/>
			{(worksite === "commute" || worksite === "project-site") && (
				<ProjectSearch
					defaultProjectId={methods.getValues("projectId")}
					onChange={(projectId) => {
						if (projectId) {
							methods.setValue("projectId", projectId);
						} else {
							methods.setValue("projectId", null);
						}
					}}
				/>
			)}
		</div>
	);
}
